import axios from 'axios'
import React from 'react'
import { baseUrl } from '../assets/Animations'
import { getRequestHeaders } from '../api'
import './income-projections.css'

const IncomeProjections = () => {
    const [timesheets, setTimesheets] = React.useState([])
    const [invoices, setInvoices] = React.useState([])
    const [tableHeaders, setTableHeaders] = React.useState([])

    React.useEffect(() => {
        axios.get(`${baseUrl}/getalltimesheetsendpoint`, getRequestHeaders())
        .then(res => {
            setTimesheets(res.data)
        })
        .catch(err => {
            console.log(err)
        })
        axios.get(`${baseUrl}/allinvoices`, getRequestHeaders())
        .then(res => {
            setInvoices(res.data)
            console.log(createTableHeaders(res.data))
            setTableHeaders(createTableHeaders(res.data))
        })
        .catch(err => {
            console.log(err)
        })
    },[])


    function createTableHeaders(invoices) {
        const uniqueHeaders = new Set();
      
        invoices.forEach(invoice => {
          const monthNumber = invoice.monthNumber;
          const year = invoice.year;
          const monthYearKey = `${monthNumber}-${year}`;
      
          if (!uniqueHeaders.has(monthYearKey)) {
            uniqueHeaders.add(monthYearKey);
          }
        });
      
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        
        const headersArray = Array.from(uniqueHeaders).map(key => {
          const [month, year] = key.split('-');
          return {
            title: `${monthNames[parseInt(month) - 1]} ${year}`,
            month: parseInt(month),
            year: parseInt(year)
          };
        });
      
        // Sort the array by year first, then by month
        headersArray.sort((a, b) => {
          if (a.year !== b.year) {
            return a.year - b.year;
          }
          return a.month - b.month;
        });
      
        return headersArray;
      }

    return (
        <div>
            <table>
                <thead>
                    <tr>
                        {tableHeaders.map((header, index) => {
                            return (
                                <th className='income-projections-table-headers' key={index}>{header.title}</th>
                            )
                        })
                        }
                    </tr>
                </thead>
                <tbody>
                    {timesheets.map((timesheet, index) => {
                        return (
                            <tr key={index}>
                                <td>{timesheet.month}</td>
                                <td>{timesheet.year}</td>
                                <td>{timesheet.lessons}</td>
                                <td>{timesheet.extras}</td>
                                <td>{timesheet.income}</td>
                            </tr>
                        )
                    })}
                    {invoices.map((invoice, index) => {
                        return (
                            <tr key={index}>
                                <td>{invoice.monthYear.split('/')[0]}</td>
                                <td>{invoice.monthYear.split('/')[1]}</td>
                                <td>{invoice.lessonsToBeBilled.length}</td>
                                <td>{invoice.extrasToBeBilled.length}</td>
                                <td>{invoice.lessonsToBeBilled.length * 50 + invoice.extrasToBeBilled.length * 10}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
export default IncomeProjections;